import React from 'react';
import { MessageCircle } from 'lucide-react';

const AttorneyChatButton = ({ variant = 'default' }) => {
  const baseClasses = "js-chat flex items-center justify-center gap-2 font-semibold transition-all duration-300";
  
  const variantClasses = {
    default: "bg-white/10 backdrop-blur-sm border-2 border-white/20 text-white hover:bg-white hover:text-black px-10 py-6 text-lg rounded-xl",
    outline: "border-2 border-white/30 hover:border-white text-white hover:bg-white/10 px-8 py-4 rounded-lg"
  };

  const text = variant === 'default' ? 'Speak with a legal expert' : 'Speak with a Legal Expert';

  return (
    <button className={`${baseClasses} ${variantClasses[variant]}`}>
      <MessageCircle className="w-5 h-5" />
      {text}
    </button>
  );
};

export default AttorneyChatButton;
